import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addNetworkFailure,
  addNetworkSuccess,
  //
  deleteNetworkSuccess,
  deleteNetworkFailure,
  //
  editNetworkSuccess,
  editNetworkFailure,
  //
  fetchNetwork as fetchNetworkAction,
  fetchNetworkFailure,
  fetchNetworkSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  //
  searchNetworkSuccess,
  searchNetworkFailure,
} from "./actions";
import {
  ADD_NETWORK,
  DELETE_NETWORK,
  EDIT_NETWORK,
  FETCH_NETWORK,
  GET_VIEW_DATA,
  SEARCH_NETWORK,
} from "./constants";

export function* fetchNetworkSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/network?${query}`,
      payload
    );
    yield put(fetchNetworkSuccess(data));
  } catch (e) {
    yield put(fetchNetworkFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching network!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/network/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addNetworkSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/network/add`, payload.data);
    if (data) {
      yield put(successAlert("Network added successfully!"));
      yield put(addNetworkSuccess());
      if (payload?.history) {
        payload.history.push(`/d/leads/networking`);
      }
    }
  } catch (e) {
    yield put(addNetworkFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editNetworkSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/network/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Network updated successfully!"));
      yield put(editNetworkSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editNetworkFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteNetworkSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const activeLocation = yield select((state) => state?.AuthReducer?.user);

  try {
    const data = yield call(
      api(token).delete,
      `/api/network/${payload?.delete_id}`
    );
    if (data) {
      yield put(successAlert("Network deleted successfully!"));
      yield put(deleteNetworkSuccess());
      yield put(
        fetchNetworkAction({
          data: { page: 1, limit: 10, location_id: payload?.location_id },
        })
      );
    }
  } catch (e) {
    yield put(deleteNetworkFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchNetworkSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";

  try {
    const data = yield call(
      api(token).get,
      `/api/network-list/search?${query}`
    );
    if (data) {
      yield put(searchNetworkSuccess(data?.data ?? []));
    }
  } catch (e) {
    yield put(searchNetworkFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchNetworkFlow() {
  yield takeEvery(FETCH_NETWORK, fetchNetworkSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addNetworkFlow() {
  yield takeEvery(ADD_NETWORK, addNetworkSaga);
}
export function* editNetworkFlow() {
  yield takeEvery(EDIT_NETWORK, editNetworkSaga);
}
export function* deleteNetworkFlow() {
  yield takeEvery(DELETE_NETWORK, deleteNetworkSaga);
}
export function* searchNetworkFlow() {
  yield takeEvery(SEARCH_NETWORK, searchNetworkSaga);
}

export default function* NetworkSaga() {
  yield all([
    fetchNetworkFlow(),
    addNetworkFlow(),
    editNetworkFlow(),
    deleteNetworkFlow(),
    getViewDataFlow(),
    searchNetworkFlow(),
  ]);
}
